import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { WhatsInsideSection } from './components/WhatsInsideSection';
import { ValueStackSection } from './components/ValueStackSection';
import { TimeObjectionSection } from './components/TimeObjectionSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCloseSection } from './components/FinalCloseSection';
import { SectionDivider } from './components/SectionDivider';
export function App() {
  return <div className="w-full min-h-screen bg-[#0a0a0a] text-white overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <SectionDivider data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <SectionDivider data-id="element-4" />
      <SolutionSection data-id="element-5" />
      <SectionDivider data-id="element-6" />
      <WhatsInsideSection data-id="element-7" />
      <SectionDivider data-id="element-8" />
      <ValueStackSection data-id="element-9" />
      <SectionDivider data-id="element-10" />
      <TimeObjectionSection data-id="element-11" />
      <SectionDivider data-id="element-12" />
      <GuaranteeSection data-id="element-13" />
      <SectionDivider data-id="element-14" />
      <FAQSection data-id="element-15" />
      <SectionDivider data-id="element-16" />
      <FinalCloseSection data-id="element-17" />

      {/* Footer */}
      <footer className="border-t border-[#1a1a1a] py-8 text-center" data-id="element-18">
        <p className="text-gray-600 text-xs tracking-wider" data-id="element-19">
          © 2026 Nano-Creative Labs. Todos los derechos reservados.
        </p>
      </footer>
    </div>;
}